import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import PolozkaApi from "../api/gen/cgo/PolozkaApi";
import {Col} from "reactstrap";
import * as EnumKodExterniPolozkaInfo from "../api/EnumKodExterniPolozkaInfo";
import * as EnumKodExterniPolozka from "../api/gen/cgo/EnumKodExterniPolozka";
import {withTranslation, WithTranslation} from "react-i18next";

const {Form, FormActions, FormBody} = form;

/**
 * Formulář pro tvorbu/úpravu párování fakturační položky.
 */
class ParovaniFakturacniPolozkaForm extends Component<WithTranslation> {

    static formName = 'ParovaniFakturacniPolozkaForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.kodExterniPolozka) {
            errors.kodExterniPolozka = t('validation.external_code_required');
        }
        if (!values.polozkaHranicePod) {
            errors.polozkaHranicePod = t('validation.item_required');
        }
        if (!values.polozkaHraniceNad) {
            errors.polozkaHraniceNad = t('validation.item_required');
        }
        if (!values.prepocet) {
            errors.prepocet = t('validation.field_required');
        }
        return errors;
    };

    filterSuggestions = (value) => {
        return PolozkaApi.getPolozky(value, false);
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.ObjectSuggest
                    label={t('labels.external_item_code')}
                    name="kodExterniPolozka"
                    dropdown={true}
                    removable={false}
                    getItemValue={(item) => item ? EnumKodExterniPolozkaInfo.getCaption(item, t) : ""}
                    renderSuggestion={item => item ? EnumKodExterniPolozkaInfo.getCaption(item, t) : ""}
                    items={EnumKodExterniPolozka.values}
                    required
                    disabled={submitting}
                />
                <ff.Number double label={t('coverage_border')} name="hranicePokryti" disabled={submitting} addonsAfter={<Col sm={10}/>}/>
                <ff.Number double label={t('recount')} name="prepocet" disabled={submitting} required addonsAfter={<Col sm={10}/>}/>
                <ff.ApiObjectSuggest
                    label={t('labels.item_under_border')}
                    name="polozkaHranicePod"
                    dropdown={false}
                    removable={false}
                    itemValueAttrName="nazev"
                    renderSuggestion={(item) => item ? item.nazev : ""}
                    filterSuggestions={this.filterSuggestions}
                    placeholder={t('search_for_item')}
                    required
                />
                <ff.ApiObjectSuggest
                    label={t('labels.item_above_border')}
                    name="polozkaHraniceNad"
                    dropdown={false}
                    removable={false}
                    itemValueAttrName="nazev"
                    renderSuggestion={(item) => item ? item.nazev : ""}
                    filterSuggestions={this.filterSuggestions}
                    placeholder={t('search_for_item')}
                    required
                />
                <ff.ApiObjectSuggest
                    label={t('labels.item_composing')}
                    name="polozkaSkladani"
                    dropdown={false}
                    removable={false}
                    itemValueAttrName="nazev"
                    renderSuggestion={(item) => item ? item.nazev : ""}
                    filterSuggestions={this.filterSuggestions}
                    placeholder={t('search_for_item')}
                />
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: ParovaniFakturacniPolozkaForm.formName,
    validate: ParovaniFakturacniPolozkaForm.validate,
})(ParovaniFakturacniPolozkaForm)));
